import { Scope, type ScopeT } from '@/types';

/**
 * Whether a scope's journey fragment carries the sections that configure payment plans as a whole —
 * `payment_plan_tiers` and `budget_assessment`. Saves below client scope strip both, so a
 * page-level guard on either must consult this too, or it blocks a save that could not have
 * written the thing it is guarding.
 */
export function scopeCarriesPlanConfig(scope: ScopeT): boolean {
  return scope === Scope.OPERATOR || scope === Scope.CLIENT;
}
